import apiService from './index'
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const submitRatings = async (data: any)  => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL}/application/feedback`, data)
  }
  